export type SearchInitialValuesStorageMapping = {
  target?: string;
  from?: string;
  defaultValue?: unknown;
};

export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function getValueByPath(value: unknown, pathText: string) {
  const parts = String(pathText || "")
    .split(".")
    .map((part) => part.trim())
    .filter(Boolean);
  return parts.reduce<unknown>((current, part) => {
    if (!current || typeof current !== "object") return undefined;
    return (current as Record<string, unknown>)[part];
  }, value);
}

export function getBrowserStorage(
  storageType: "sessionStorage" | "localStorage",
) {
  if (typeof window === "undefined") return null;
  return storageType === "localStorage"
    ? window.localStorage
    : window.sessionStorage;
}

export function unwrapSearchStorageValue(value: unknown, now = Date.now()) {
  if (!isPlainObject(value) || value.__mijalowcodeStorage !== true) {
    return value;
  }
  const expiresAt = Number(value.expiresAt || 0);
  if (expiresAt > 0 && expiresAt <= now) return undefined;
  return value.value;
}

export function buildSearchInitialValuesFromStorageValue(
  storageValue: unknown,
  mappings: SearchInitialValuesStorageMapping[] = [],
) {
  if (!isPlainObject(storageValue)) return {};
  if (!Array.isArray(mappings) || mappings.length === 0) {
    return { ...storageValue };
  }
  return mappings.reduce<Record<string, unknown>>((acc, mapping) => {
    const target = String(mapping.target || "").trim();
    if (!target) return acc;
    const from = String(mapping.from || target).trim();
    const value = from ? getValueByPath(storageValue, from) : undefined;
    acc[target] = value === undefined ? mapping.defaultValue : value;
    return acc;
  }, {});
}

export function buildProTableFormConfig(
  searchInitialValues: Record<string, unknown>,
) {
  if (Object.keys(searchInitialValues).length === 0) return undefined;
  return {
    initialValues: searchInitialValues,
  };
}
